import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import('./assets/semantic.min.css')
import('./assets/styles.css')
import('./assets/multi-select-tag.css')
import locations from './locations.json'
import areas from './areas.json'
import OfflineUploader from './OfflineUploader.vue'

const testversion=false;

const app =createApp(App).use(router)

app.config.globalProperties.$locations = locations.locations;
app.config.globalProperties.$areas = areas.areas;
app.config.globalProperties.$getLocationOfIns = (ins, thiz) => {
  var i;
  var l = ins.location;
  if (!ins.location) {
    return '- no data -';
  }

//  console.log(thiz.$locations);

  if (typeof ins.location === 'string') {
    try {
      l = JSON.parse(ins.location);
      ins.location = l;
      // console.log(27, typeof l, l);
    }
    catch(e){
      console.log('error', e);
    }
  }

  if (typeof l === 'object') {
    if (l.lat) {
      // console.log(36, typeof l, l);
      return 'Lat:'+l.lat+', lon:'+l.lon;
    }
    else if (l.id) {
      for (i=0; i< thiz.$locations.length; i++) {
        if (thiz.$locations[i].id === l.id) return thiz.$locations[i].firstname+' '+thiz.$locations[i].surname+'('+thiz.$locations[i].companyname+')';
      }

      // console.log(44, typeof l, l);
      return 'invalid value:'+JSON.stringify(l);
    }
  }

  if (typeof l === 'number') {
    for (i=0; i< thiz.$locations.length; i++) {
      if (thiz.$locations[i].id === l) return thiz.$locations[i].firstname+' '+thiz.$locations[i].surname+'('+thiz.$locations[i].companyname+')';
    }
  }

  //    console.log(55, typeof l, l);
  return l;
}

// function updateOnline() {
//   app.config.globalProperties.$online = navigator.onLine;
//   setTimeout(updateOnline, 1000);
// }

app.config.globalProperties.$getInspectionSummary = (ins, thiz) =>{
  var t='';
  
  var nums = {
    '1':1,
    '2':2,
    '3':3,
    '4':4
  };

  var ftl = {
    'E': "empty",
    "1/8":'one eighth',
    '1/4':'quarter',
    "3/8":'three eighth',
    '1/2':'half',
    "5/8":'five eighth',
    '3/4':'three quarters',
    "7/8":"seven eighth",
    'F':'full'
  };
  
  var cleans={
    "clean":"Clean",
    "dust":"Light dust",
    "small":"Small cleaning required",
    "medium":"Medium cleaning required",
    "dirty":"Full cleaning required"
  };
  
  var dps = {
    "na":"not applicable",
    "allgood":"all in good condition",
    "slightlydamaged":"slightly damaged",
    "damaged":"damaged",
    "onemissing":",one missing",
    "allmissing":"all missing"
  };
  
  var umb= {
    "na":"not applicable",
    "0f2":"2 umbrellas",
    "1f2":"1 of 2 missing",
    "2f2":"2 of 2 missing",
    "0f4":"4 umbrellas",
    "1f4":"1 of 4 missing",
    "2f4":"2 of 4 missing",
    "3f4":"3 of 4 missing",
    "4f4":"4 of 4 missing"
  };
  
  var spw = {
    "na":"not applicable",
    "good":"in good condition",
    "damaged":"damaged",
    "missing":"missing",
    "nowarnings":"no warnings",
    "warnings":"warning(s)",
    "present":"present",
    "hbp":"handbook present",
    "clean":"clean",
    "empty":"empty"
  };
  
  var png = {
    "na":"not applicable",
    "allgood":"both present",
    "onlypump":"only pump",
    "onlygunk":"only tyre repair kit",
    "bothmissing":"both missing"
  };
  var tyres = {
    'ok':'Ok',
    'damaged':'Damaged',
    'wear':'Wear'
  };

  var yesno = {
    'yes':'Yes',
    'no':'No'
  }
  
  ins.location = thiz.$getLocationOfIns(ins, thiz);
  t += 'Location:'+ins.location+'; ';
  t += 'Mileage:'+ins['mileage']+'; ';
  t += 'Fuel: '+ftl[ins.fuellevel]+'; ';
  t += cleans[ins.insideclean]+' inside, ';
  t += cleans[ins.outsideclean]+' outside; ';
  if (ins['numkeys']) t += 'Keys: '+nums[ins.numkeys]+', ';
  if (ins['tyres']) t += 'Tyres: '+tyres[ins.tyres]+', ';
  if (ins['parcelshelf']) t += 'Parcel shelf: '+yesno[ins.parcelshelf]+', ';
  t += 'Door protectors: '+dps[ins.doorprotectors]+'; ';
  t += 'Glovebox: '+spw[ins.glovebox]+'; ';
  t += 'Centre console: '+spw[ins.cconsole]+'; ';
  t += 'Wheelnut: '+spw[ins.wheelnut]+'; ';
  t += 'Door pockets: '+spw[ins.doorpockets]+'; ';
  t += 'Dashboard lights: ';
  if (ins.dashlights && ins.dashlights.length>0) {
    t+= ins.dashlights;
  }
  else {
    t+='-';
  }
  t+= '; ';

  t += 'Any other: ';
  if (ins.anyother && ins.anyother.length>0) {
    t+=ins.anyother;
  }
  else {
    t+='-';
  }
  t+='; ';

  t += 'Umbrellas: '+umb[ins.umbrellas]+ ';';
  t += 'Spare wheel: '+spw[ins.sparewheel]+'; ';
  t += 'Pump&tyre repair kit:'+png[ins.pumpngunk];
  if (!ins.damages) ins.damages =[];
  
  return t;
}

// app.config.globalProperties.$online = false;

// setTimeout(updateOnline, 0);

app.config.globalProperties.$error = null;
app.config.globalProperties.$info = null;

if (testversion) {
  app.config.globalProperties.$host = 'https://pwat.2f7.uk'
}
else {
  app.config.globalProperties.$host = 'https://starthill.2f7.uk'
}

app.config.globalProperties.$offlineUploader = new OfflineUploader(testversion, app.config.globalProperties.$host)

navigator.serviceWorker.ready.then(function(swRegistration) {
  // app.config.globalProperties.$swreg = swRegistration;
  app.config.globalProperties.$swpost = (title, msg) => {
    swRegistration.active.postMessage(JSON.stringify({title:title, msg:msg}));
  }

});

app.config.globalProperties.$addOfflineItem = (url, options, id) =>{
  var r = {
    "url": url,
    "options":options,
    "id": id || Date.now()
  };

  r = JSON.parse(JSON.stringify(r));
  var request = indexedDB.open("TFSPWAPostDB");
  request.onsuccess = function (event) {
    var db = event.target.result;
    var tx = db.transaction('postrequests', 'readwrite');
    var store = tx.objectStore('postrequests');
    store.add(r);
  }

  request.onupgradeneeded = (event)=>{
    var db = event.target.result;
    if (!db.objectStoreNames.contains('postrequests')) {
      db.createObjectStore("postrequests", { keyPath: 'id', autoIncrement: true });
    }
    else {
      db.objectStoreNames.get('postrequests');
    }
  };
};

app.mount('#app')
